import React, { useRef, useStat, useEffect, useState } from "react";
import { Form, Button, Alert, Row, Col, utils } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { getUserRoleByEmail } from "./utils";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { login } = useAuth();

  const [error, setError] = useState("");
  const [redirectTo, setRedirectTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  let navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);

      const params = new URLSearchParams(window.location.search);
      const redirectTo = params.get("redirect_to");

      // Fetch user role using the getUserRoleByEmail function
      const userRole = await getUserRoleByEmail(emailRef.current.value);

      // If userRole is not null, proceed with login
      console.log("User role:", userRole);
      await login(emailRef.current.value, passwordRef.current.value);
      console.log("logged in");
      setLoggedIn(true);

      if (redirectTo) {
        navigate(redirectTo || "/");
      } else {
        navigate("/");
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectTo = params.get("redirect_to");
    if (redirectTo) {
      setRedirectTo(`?redirect_to=${redirectTo}`);
    }
  }, []);

  return (
    <>
      {redirectTo && (
        <h5 className="mt-2" style={{ fontWeight: 600 }}>
          Please login or create an account to rent a boat.
        </h5>
      )}
      <p className="auth-description">
        Please sign-in to your account and continue to the dashboard.
        <br />
        Don't have an account?
        <br />
        <Link to={`/auth/signup-renter${redirectTo}`}>Register as Renter </Link>
        OR
        <Link to={`/auth/signup-owner${redirectTo}`}> Boat Owner </Link>
        OR
        <Link to={`/auth/signup-referral${redirectTo}`}> Referral Program</Link>
      </p>
      <div className="row">
        <div className="col">
          {loggedIn && (
            <Alert variant="success">
              You have been successfully logged in!
            </Alert>
          )}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col>
                <Form.Group id="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    className="form-control"
                    ref={emailRef}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group id="password">
                  <Form.Label>Password</Form.Label>
                  <div style={{ position: "relative", width: "100%" }}>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      ref={passwordRef}
                      required
                      style={{ paddingRight: "2.5rem" }}
                    />
                    <button
                      type="button"
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "0.5rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        height: "2rem",
                        width: "2rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {showPassword ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-5 0-9.27-3.11-11-7 1.21-2.61 3.31-4.77 6-6.13" />
                          <path d="M1 1l22 22" />
                          <path d="M9.53 9.53A3.5 3.5 0 0 0 12 16.5c1.38 0 2.63-.56 3.54-1.47" />
                          <path d="M14.47 14.47A3.5 3.5 0 0 1 12 7.5c-.88 0-1.68.32-2.32.84" />
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </button>
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-end">
                <Link
                  to="/auth/forgot-password"
                  className="text-muted text-decoration-underline mb-3"
                  style={{ marginTop: "-11px" }}
                >
                  Forgot Password?
                </Link>
              </Col>
            </Row>
            <Button disabled={loading} className="w-100" type="submit">
              Login
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
}
